import { Dashboard } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { Card, CardHeader, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import PageLoading from "../../../components/Loading/PageLoading";
import request from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { allCalldetails } from "../callQuery";
import TableComponent from "../../../components/GridTable/TableComponent";

export default function CallListTable() {
  const [isLoading, setIsLoading] = useState(false);
  const [calltableData, setcalltableData] = useState([]);
  const navigate = useNavigate();
  const handleNewCall = (e) => {
    navigate("/call-details/add-call");
  };

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const callListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.NO",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Call Log ID",
        field: "clgid",
        name: "Call Log ID",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      // {
      //   headerName: "Name",
      //   field: "name",
      //   name: "Name",
      //   flex: 1,
      //   editable: false,
      //   disableColumnMenu: true,
      // },
      {
        label: " Organization Name",
        field: "organizationName",
        name: "organizationName",
        flex: 1.2,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Phone No.",
        field: "phoneNo",
        name: "Ph Number",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Call Date",
        field: "callstartDate",
        name: "Start Date",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Call Time",
        field: "callstartTime",
        name: "Start Time",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created At",
        field: "createdDate",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: calltableData.sort((a, b) => b.id - a.id).map((item, index) => ({
      sno: index + 1,
      id: item.id,
      clgid: item.clgid,
      name: item.name,
      organizationName: item.organization,
      phoneNo: item.phoneNo,
      callstartDate: item.callstartDate,
      callstartTime: item.callstartTime,
      createdBy: item.user.username,
      createdDate: item.createdAt.slice(0, 10),
    }))
  
    
  };
  const fetchCallData = () => {
    setIsLoading(true);
    request(BASEURL, allCalldetails).then((res) => {
      setcalltableData(res.allCalldetails);
    })
    .finally(() => {
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchCallData();
  }, []);

  const onCallForm = (e) => {
    if (e?.id) {
      navigate(`/call-details/add-call?${e?.id}`);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
    const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }
  return (
    <>
      <DashboardLayout>
        <TableComponent
        tableLoading={isLoading ? true : false}
        columns={callListTable.columns}
        rowsData={callListTable.rows}
        head="Call List"
         actions={true}
         checked={false}
         view={true}
         showAdd = {true}
         onCheck={onCheck}
         onEdit={onCallForm}
         // onDelete={onDelete}
         onView={onCallForm}
         onDeleteALL={onDeleteALL}
         addList={() => handleNewCall()}
        />
        {/* <Card>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Call Log List
                  </MaterialTypography>
                </Stack>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => handleNewCall()}
                >
                  Add Call
                </MaterialButton>
              </Stack>
            }
          ></CardHeader>
          {!isLoading && (
            <MaterialDataGrid
              rows={callListTable.rows}
              columns={callListTable.columns}
              onRowClick={onCallForm}
              loading={pageState.loading}
              localeText={{
                noRowsLabel: (
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                  >
                    <MaterialTypography
                      variant="body2"
                      fontWeight="medium"
                      color="text"
                    >
                      No Call found
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      You have not yet add any Call details. Click on the "Add
                      Call" button to start adding Call details.
                    </MaterialTypography>
                  </Stack>
                ),
              }}
            />
          )}

          {isLoading && <PageLoading />}
        </Card> */}
      </DashboardLayout>
    </>
  );
}
